import {
  SearchAbandonedCheckoutsResponse,
  Search,
} from './src/ecom-v1-abandoned-checkout-abandoned-checkouts.universal';

export * from './src/ecom-v1-abandoned-checkout-abandoned-checkouts.universal.js';

/** @hidden */
export type AbandonedCheckoutSearch = {};

/**
 * Retrieves a list of abandoned checkouts, given the provided paging, filtering, search details and sorting. Up to 100 abandoned checkouts can be returned per request.
 * @param search - Search options.
 * @public
 * @requiredField search
 * @permissionId ECOM.ABANDONED_CHECKOUT_READ
 * @applicableIdentity APP
 * @fqn wix.ecom.abandoned_checkout.api.v1.AbandonedCheckoutService.SearchAbandonedCheckouts
 */
export declare function searchAbandonedCheckouts(
  search: Search
): Promise<SearchAbandonedCheckoutsResponse>;
